export default {"src":"/_next/static/media/rainbow-blue-to-purple-left.d123d700.svg","height":220,"width":1920,"blurWidth":0,"blurHeight":0};